export class Endereco {
    bairro: string;
    cep: string;
    complemento: string;
    gia: string;
    ibge: string;
    cidade: string;
    rua: string;
    estado: string;
    unidade: string;
    erro: boolean;
    latitude: number;
    longitude: number;
    numero: number;
    id: number;

    constructor(e) {
        //viacep || base de dados
        this.bairro = e['bairro'] || '';
        this.cep = e['cep'] || '';
        this.cidade = e['localidade'] || e['cidade'] || '';
        this.rua = e['logradouro'] || e['rua'] || '';
        this.estado = e['uf'] || e['estado'] || '';
        this.unidade = e['unidade'] || '';
        this.erro = e['erro'] || false;
        //somente maps
        this.latitude = e['latitude'] || -23.5023306;
        this.longitude = e['longidude'] || -46.6337542;
        //somente viacep
        this.complemento = e['complemento'] || '';
        this.gia = e['gia'] || '';
        this.ibge = e['ibge'] || '';
        //base de dados
        this.numero = e['numero'] || null;
        this.id = e['id'] || null;
    }

    strSearchMaps(): string {
        return this.rua + ', ' + this.bairro + ' - ' + this.cidade + ' - ' + this.estado;
    }

}